<template>
  <v-app>
    <DashboardTopNav @toggle-rail="toggleRail"/>
    <DashboardAppNav
      v-if="shouldSideNavShow()"
      :model-value="true"
      :rail="rail"
      @update:rail="val => rail = val"
      :is-mobile="isMobile"
    />

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
  <FooterContainer v-if="!shouldSideNavShow()" />
</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRoute } from 'vue-router';
import { ref, onMounted, onUnmounted, watch } from 'vue';

import DashboardTopNav from './components/navigation/DashboardTopNav.vue';
import DashboardAppNav from './components/navigation/DashboardAppNav.vue';
import FooterContainer from './components/navigation/FooterContainer.vue';
import { MOBILE_BREAKPOINT } from './composables.js';

export default {
  name: 'App',
  components: {
    DashboardTopNav,
    DashboardAppNav,
    FooterContainer,
  },
  setup() {
    const { isAuthenticated } = useAuth0();
    const route = useRoute();
    const rail = ref(false);
    const isMobile = ref(window.innerWidth <= MOBILE_BREAKPOINT);

    const updateIsMobile = () => {
        isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT;
    };

    const shouldSideNavShow = () => {
        const isOnboarding = route.path.startsWith('/console/onboarding');
        return isAuthenticated.value && !route.meta.public && !isOnboarding;
    };

    const toggleRail = () => {
        // Toggle rail mode on both desktop and mobile
        rail.value = !rail.value;
    };

    // Watch isMobile and update rail state accordingly
    watch(isMobile, (newIsMobile) => {
        if (newIsMobile) {
            // Mobile: start in rail (collapsed) mode
            rail.value = true;
        } else {
            // Desktop: start expanded
            rail.value = false;
        }
    }, { immediate: true });

    onMounted(() => {
        window.addEventListener('resize', updateIsMobile);
        updateIsMobile();
        window.scroll(0,0);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateIsMobile);
    });

    return {
      isAuthenticated,
      isMobile,
      shouldSideNavShow,
      rail,
      toggleRail
    };
  },
}
</script>

<style>
@import './assets/styles/variables.css';
@import './assets/styles/VuetifyMods.css';

@font-face {
    font-family: Degular-Regular;
    src: url('./assets/fonts/Degular/Degular-Regular.otf');
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
}
</style>